import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {State} from '../../interfaces'
import common from '../../slices/common'
import deliveryInfo from '../../slices/deliveryInfo'
import error from '../../slices/error'
import orderClaimInfo from '../../slices/orderClaimInfo'
import orderPaymentDetail from '../../slices/orderPaymentDetail'
import pagination from '../../slices/pagination'
import productBundle from '../../slices/productBundle'
import saleHistory from '../../slices/saleHistory'
import search from '../../slices/search'
import transactionHistory from '../../slices/transactionHistory'

const createRootReducer = (): Reducer<State> =>
    combineReducers({
        common,
        deliveryInfo,
        error,
        router: routerReducer,
        orderClaimInfo,
        orderPaymentDetail,
        pagination,
        productBundle,
        saleHistory,
        search,
        transactionHistory,
    })

export default createRootReducer
